/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : CORRECT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	correct: {
		
		// ..... ICON ..... //
		'& .icon': {
			border: replacePXinStringWithEM(`1px solid ${theme.color.light.light.swatch}`),
			borderRadius: '100%',
			cursor: 'pointer',
			width: pxToEm(20),
			height: pxToEm(20),
		},
		
		// ..... INSTRUCTION ..... //
		'& .instruction': {
			display: 'none',
			fontSize: pxToEm(11)
		},

		// +++++ IMAGE 1 +++++ //
		'&.image1': {
			'& .icon': {
				margin: replacePXinStringWithEM('5px auto 0')
			}
		},

		// +++++ IMAGE 2 +++++ //
		'&.image2': {
			'& .icon': {
				margin: replacePXinStringWithEM('5px auto 0')
			}
		},

		// +++++ TEXT 1 +++++ //
		'&.text1': {
			position: 'absolute',
			top: '45%',
			left: '-10.5%', // this gets adjusted in embed_styles for in-content units
			zIndex: '3',
			transform: 'translateY(-50%)'
		},

		// +++++ TEXT 2 +++++ //
		'&.text2': {
			position: 'absolute',
			top: '45%',
			left: '-5%',
			zIndex: '3',
			transform: 'translateY(-50%)'
		},

		// ..... CORRECT/INCORRECT STATE ..... //
		'&.isCorrect-true': {
			// '& .icon': {
			// 	backgroundColor: theme.color.light.light.swatch,
			// 	backgroundImage: `url(${url.image.app}/icon-check-green.png)`
			// },
			'& .icon': {
			    background: theme.color.secondary.medium.swatch,
			    borderRadius: '100%',
			    position: 'relative',
			},
			'& .symbol': {
			    display: 'inline-block',
			    transform: 'rotate(45deg)',
			    position: 'absolute',
			    top: '-35%',
			    left: '0',
			    width: '100%',
			    height: '100%',
			    fontSize: '120%',
			    '&:before, &:after': {
			    	content: '""',
				    position: 'absolute',
				    width: pxToEm(3),
				    backgroundColor: theme.color.light.light.swatch
			    },
			    '&:before': {
			    	height: pxToEm(9),
			    	left: pxToEm(11),
			    	top: pxToEm(6)
			    },
			    '&:after': {
			    	height: pxToEm(3),
			    	left: pxToEm(8),
			    	top: pxToEm(12)
			    }
			}
		},

		// ^.^ VALIDATION STYLES ^.^ //
		'&.isValid-false': {
            '& .icon': {
                background: theme.color.attention.medium.swatch
            },
		}
		
	}
});